// /a/:slug → counts a click + redirects to the affiliate target URL.
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, AlertCircle } from "lucide-react";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export default function AffiliateRedirect() {
  const { slug } = useParams();
  const [err, setErr] = useState("");
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    // 6-second stuck-state watchdog — if we haven't redirected by then
    // the tracking API is unresponsive; surface a fallback UI instead
    // of a forever-spinner.
    const watchdog = setTimeout(() => setStuck(true), 6000);
    (async () => {
      try {
        const r = await fetch(`${API}/api/a/${encodeURIComponent(slug)}`);
        const d = await r.json().catch(() => ({}));
        if (!r.ok || !d?.target_url) {
          clearTimeout(watchdog);
          setErr(d?.detail || "Tracking link not found.");
          return;
        }
        try { sessionStorage.setItem("cr_aff", slug); } catch (_) { /* noop */ }
        clearTimeout(watchdog);
        window.location.replace(d.target_url);
      } catch (e) {
        clearTimeout(watchdog);
        setErr(e?.message || "Network error");
      }
    })();
    return () => clearTimeout(watchdog);
  }, [slug]);

  if (err || stuck) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center text-slate-700 text-sm px-6" data-testid="affiliate-redirect-error">
        <div className="text-center max-w-sm">
          <AlertCircle className="w-8 h-8 text-rose-600 mx-auto mb-2"/>
          <div className="font-semibold text-slate-900">{err || "This tracking link didn't resolve."}</div>
          <div className="text-xs text-slate-500 mt-1">Head to the homepage and we&apos;ll get you where you were going.</div>
          <a href="/" className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-emerald-700 text-white font-semibold hover:bg-emerald-800">Go to homepage</a>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center text-slate-600 text-sm" data-testid="affiliate-redirect">
      <div className="inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin"/>Redirecting…</div>
    </div>
  );
}
